import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {CSSProperties} from 'react';


const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    height: 'auto',
    width: '600px',
    maxWidth: '90%',
    minWidth: '300px',
    maxHeight: '80%',
    background: 'white',
    padding: '0 20px 20px 20px',
    marginBottom: '20px',
    alignSelf: 'center',
    marginTop:'30px',
    borderRadius:'20px'
    
}

const woStyle: React.CSSProperties = {
    fontSize: '35px',
    letterSpacing: '12px',
    fontWeight: 'lighter',
    textTransform: 'uppercase',
    color: 'rgba(88,88,88,0.8)',
    textAlign: 'center',
    margin: '8px 0 0 0'
}

const contentStyle: CSSProperties = {
    backgroundColor: 'white',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    borderRadius:'20px'
}
const imgStyle: React.CSSProperties = {
    alignSelf: 'center',
    width: 'auto',
    height: 'auto',
    maxHeight: '560px',
    margin: '25px auto',
}

type Props = {
    proofId: string;
}

export class CampusProofCard extends React.Component<Props, any>{

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    render(){
        var imgPath = Tgcc.getProofPath(this.props.proofId);
        return (
            <div style={wrapperStyle} className='proofWrapper'>
                <div style={contentStyle}>
                    <img style={imgStyle} src={imgPath} onError={this.onError} className="pfImg"/>
                </div>
            </div>
        )
    }
}

